import React,{Component} from "react";
import appinfo from "../../clientsJSON";
// import "./index.css";
import Menu from "../../component/Menu";
import Footer from "../../component/footer";

;

class About extends Component {
    render(){
        document.title = "About Us | " + appinfo.name;
        return (
            <div>
                <Menu/>
                <div className="mp-container" style={{textAlign:"center",padding:50}}>
                    <h1>About Us</h1>
                    <p style={{textAlign:"justify"}}>{appinfo.about.description}</p>
                    <h2>{appinfo.about.cta}</h2>
                </div>
                <Footer/>
            </div>
        )
    }
}
export default About;